/**
 * Converts a Uint8Array to a Base64-encoded string.
 * @param bytes - The byte array to convert
 * @returns Base64-encoded string
 */
export const bytesToBase64 = (bytes: Uint8Array): string => {
  const binString = Array.from(bytes, (byte) => String.fromCharCode(byte)).join("");

  return btoa(binString);
};
